import styled from "@emotion/styled";
import { colors } from "src/theme";

const CardStyle = styled.div((props: { background?: string }) => ({
  backgroundColor: props.background || colors.background7,
  width: '100%',
  borderRadius: '8px',
  padding: 0
}));

const ContentStyle = styled.div((props: { padding?: string | number }) => ({
  padding: props.padding || '16px 32px',
  paddingBottom: 32
}));

interface CardWithTitleProps {
  children: React.ReactNode;
  padding?: string | number;
  background?: string;
  style?: React.CSSProperties;
  className?: string;
}

export const CardWithTitle = ({ children, padding, background, className, style }: CardWithTitleProps) => {
  return (
    <CardStyle background={background} style={style} className={className}>
      <ContentStyle padding={padding}>
        {children}
      </ContentStyle>
    </CardStyle>
  );
};
